import { FEATURES } from '@/access/features';
import { HOME_SLUG, pageHref } from './pageTree';

export const PAGES_PREVIEW_ROUTE = 'pages-preview';
export const PAGES_PREVIEW_PATH = '/pages/preview';
export const PAGES_PREVIEW_SURFACE = 'pages-preview';

const PAGES_SLUG_ROUTE = 'pages-slug';

function flagReader(isFeatureEnabled) {
  return typeof isFeatureEnabled === 'function'
    ? (feature) => !!isFeatureEnabled(feature)
    : () => false;
}

/**
 * True when the org sees Pages only through the hidden preview route: home
 * stays the legacy view, so Pages home links must point back at the preview.
 */
export function isPagesPreviewOnly(isFeatureEnabled) {
  const enabled = flagReader(isFeatureEnabled);
  return !enabled(FEATURES.PAGES) && enabled(FEATURES.PAGES_PREVIEW);
}

export function pagesHref(slug, isFeatureEnabled) {
  const key = String(slug || HOME_SLUG).replace(/^\/+|\/+$/g, '');
  const isHome = !key || key === HOME_SLUG;
  if (isHome && isPagesPreviewOnly(isFeatureEnabled)) {
    return PAGES_PREVIEW_PATH;
  }
  return pageHref(slug);
}

/**
 * Chat surface for the current route. The Cy worker registers page tools only
 * for this surface plus a signed JWT claim, so it must stay off every route
 * outside the preview.
 */
export function chatSurface(route, isFeatureEnabled) {
  const name = route?.name;
  if (!flagReader(isFeatureEnabled)(FEATURES.PAGES_PREVIEW)) return null;
  if (name === PAGES_PREVIEW_ROUTE) return PAGES_PREVIEW_SURFACE;
  if (name === PAGES_SLUG_ROUTE && isPagesPreviewOnly(isFeatureEnabled)) {
    return PAGES_PREVIEW_SURFACE;
  }
  return null;
}
